export default __webpack_public_path__ + "static/female-925ad7fe4c15a53f2246444b31a3274a.png";